class LeaderCard {
    constructor(element) {
        this.item = element;
        this.dialog = this.item.querySelector('dialog');

        this.listen();
    }

    listen() {
        this.item.querySelector('a[href="#modal"]').addEventListener('click', (e) => {
            e.preventDefault();
            this.open();
        });

        this.item.querySelector('.close').addEventListener('click', (e) => {
            e.preventDefault();

            this.close();
        });
    }

    open() {
        var url = new URLSearchParams(window.location.search);
        var trp_editor = url.get('trp-edit-translation');
        if(typeof trp_editor !== 'undefined' && trp_editor === 'preview') {
            /**
             * Modal mode puts the dialog at the top of the stack, causing the translation editor's interaction buttons to be hidden behind.
             * This change allows the translation editor to be used in preview mode.
             */
            if(!jQuery(this.dialog).hasClass('editor-dialog')) {
                jQuery(this.dialog).addClass('editor-dialog');
            }
            this.dialog.show();
        }else{
            this.dialog.showModal();
        }
    }

    close() {
        this.dialog.close();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelectorAll('.leader-card');

    if (wrapper.length) {
        wrapper.forEach((item) => {
            new LeaderCard(item);
        });
    }
});